import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { IArea } from 'types/map';
import { IAppState } from 'types/app';
import { Marker } from 'react-leaflet';
import L from 'leaflet';
import classnames from 'classnames';
import { MAP_BASE_URL, PLAYER_MARKER_HEIGHT, PLAYER_MARKER_WIDTH } from 'components/Map/constants';
import { xy } from 'components/Map/util';

interface Props {
  areas?: IArea[],
  avatarImage: string,
  currentArea?: IArea,
}

export function PlayerMarkers({
  areas,
  currentArea,
  avatarImage,
}: Props) {
  return (
    <Fragment>
      {(areas || [])
        .filter(area => area.labelX !== undefined && area.labelY !== undefined)
        .map(area => {
        // TODO(sdob) use area key, although we shouldn't ever be in a loc where we don't have the id
        const isCurrentArea = area.id === currentArea?.id;
        return (
          <Marker
            key={area.areaKey}
            icon={new L.Icon({
              className: classnames('map__player-marker', isCurrentArea && 'map__player-marker--visible'),
              iconUrl: `${MAP_BASE_URL}/playermarkers/${avatarImage}-player-marker.png`,
              iconSize: new L.Point(PLAYER_MARKER_WIDTH, PLAYER_MARKER_HEIGHT),
              iconAnchor: new L.Point((112 / 4) + 16, 159 / 2 + 8),
            })}
            position={xy(area.labelX!, area.labelY!)}
          />
        );
      })}
    </Fragment>
  );
}

const mapStateToProps = (state: IAppState) => ({
  areas: state.map.areas,
  currentArea: state.map.currentArea,
  avatarImage: state.myself.character.avatarImage,
});

export default connect(mapStateToProps)(PlayerMarkers);